import { adgAdConfig as adgAdConfigPortal } from './portal';
import { adgAdConfig as adgAdConfigApp } from './app';

// SDKサンプル用のsampleを用意しておく
// eslint-disable-next-line import/prefer-default-export
export const adgAdConfig = {
    portal: {
        ...adgAdConfigPortal,
    },
    app: {
        ...adgAdConfigApp,
    },
};
